<template>
  <artmisads-modal :maskClosable="false" v-model:open="visible"
    :title="modalTitle"
    :width="600" :footer="null" @cancel="handleClose">
    <div class="edit-modal">
      <div v-if="formData.type === 'multi'">
        <div class="title" style="margin-bottom: 8px;">{{ $t('seller.common.brand') }}</div>
        <div class="tags-container">
          <span v-if="currentTags.length === 0" class="tags-empty">{{ $t('seller.publishersPage.noTagContent') }}</span>
          <div v-for="tag in currentTags" :key="tag.brandId" class="tag-item">
            <LogoImage :maxWidth="'95%'" :logoUrl="tag?.logoImageUrl" :brandName="tag?.amazonBrandName" :width="20"
              :height="20" :lineHeight="6" :fontSize="5" :borderRadius="4" />
            <span>{{ tag.amazonBrandName }} {{ tag.hasDuplicate ? `(${tag.amazonProfileAccountInfoName})` : '' }}</span>
          </div>
        </div>
      </div>
      <!-- Brand and Status Section  -->
      <div class="brand-section" v-if="formData.type === 'single'">
        <div class="brand-info">
          <div class="info-item">
            <div class="info-item-content">
              <div class="label">{{ $t('seller.publishersPage.labelBrandColon') }}</div>
              <span class="value">{{ formData.brandName }}</span>
            </div>
          </div>
          <div class="info-item">
            <div class="info-item-content">
              <div class="label">{{ $t('seller.publishersPage.labelStatusColon') }}</div>
              <Status :text="formData.status === 'active' ? $t('seller.brandsPage.partnershipPartnered') : $t('seller.brandsPage.partnershipNotPartnered')" :type="formData.status" />
            </div>
          </div>
        </div>
      </div>
      <!-- Current Commission Rate -->

      <div class="current-commission" v-if="formData.status === 'active' && formData.type !== 'multi'">
        <div class="title">{{ $t('seller.publishersPage.currentCommissionRate') }}</div>
        <artmisads-button disabled class="current-commission-button">{{ formData.currentCommissionRate ?
          formData.currentCommissionRate.toFixed(1) : '0.0' }}%</artmisads-button>
      </div>

      <!-- 中间 -->
      <div class="commission-section">
        <div class="title" v-if="formData.status === 'inactive'">{{ $t('seller.brandsPage.commissionRate') }}</div>
        <div class="title" v-if="formData.status === 'active'">
          {{ $t('seller.publishersPage.modifyCommissionRate') }}
          <a-popover placement="right">
            <template #content>
              <p>{{ $t('seller.publishersPage.modifyCommissionPopover') }}</p>
            </template>
            <Icon name="wenhao-tianchong" style="color: #CCC7D9;" />

          </a-popover>
        </div>
        <div class="content">
          <div class="commission">
            <div class="commission-input">
              <span>{{ $t('seller.brandsPage.publisherCommission') }}</span>
              <artmisads-input-number :placeholder="$t('seller.common.pleaseEnter')" :disabled="!isCommissionDisabled" :min="0"
                :max="100" suffix="%" :step="0.5" size="large" @blur="commissionBlur" v-model:value="commission"
                @change="handleChangeCommission($event)" />

            </div>
            <span>+</span>
            <div class="fees" ref="fees">
              <span>{{ $t('seller.brandsPage.artemisAdsFees') }}
                <!-- <a-tooltip :getPopupContainer="() => $refs.fees">
                  <template #title>Publisher Commission x 20%, Max 3.5%</template>
                  <Icon name="wenhao-tianchong" class="question-icon" />
                </a-tooltip> -->
              </span>
              <artmisads-button disabled>
                <!-- {{ fees.toFixed(1) }}% -->
                3.0%
              </artmisads-button>
            </div>
            <span>=</span>
            <div class="total">
              <span>{{ $t('seller.brandsPage.totalLabel') }}</span>
              <artmisads-button disabled>
                <span>{{
                  commission
                    ? parseFloat(3 + Number(commission)).toFixed(1)
                    : 3.0
                }}</span>
                <span>%</span>
              </artmisads-button>
            </div>
          </div>

        </div>
      </div>
      <!-- Collaboration Period -->
      <div class="collaboration-section" ref="setCommissionRef">
        <div class="section-title">{{ $t('seller.brandsPage.collaborationPeriod') }}</div>
        <div class="date-row">
          <div class="date-group" v-if="showStartDate()">
            <div class="date-label">{{ $t('seller.brandsPage.startDate') }}</div>
            <a-date-picker :disabled="formData.status === 'active'" v-model:value="formData.startDate"
              :placeholder="$t('seller.common.selectDate')" format="YYYY-MM-DD" class="date-picker" :disabled-date="disabledStartDate"
              @change="handleStartDateChange" :getPopupContainer="() => $refs.setCommissionRef" />
          </div>
          <div class="date-group">
            <div class="date-label">{{ $t('seller.brandsPage.endDate') }}</div>
            <a-date-picker :disabled="isAutoRenew" :allowClear="true" picker="month" close-on-select
              v-model:value="formData.endDate" :placeholder="$t('seller.common.selectMonth')" format="YYYY-MM-DD" class="date-picker"
              :disabled-date="disabledEndDate" :allow-clear="false" @change="handleEndDateChange"
              :getPopupContainer="() => $refs.setCommissionRef" />
          </div>

        </div>
      </div>
      <div class="auto-renew-section">
        <a-radio v-model:checked="isAutoRenew" @change="handleAutoRenewChange"
          @click="handleRadioClick">{{ $t('seller.brandsPage.continuous') }}</a-radio>
      </div>
      <div class="collapseBox" v-if="formData.type === 'single'">
        <div class="top" :style="{ alignItems: isCollapsed ? 'center' : 'flex-start' }">
          <Icon name="info-tianchong" class="tianchong" :style="{ marginTop: isCollapsed ? '' : '6px' }" />
          <div class="content">
            <div class="title">
            <div>
              {{ $t('seller.publishersPage.accPolicyTitleOpen') }}<Icon
                :name="CURRENCY_MAPPER[amazonCountryCode].icon" class="icon"></Icon>{{ $t('seller.publishersPage.accPolicyTitleClose', { host: CURRENCY_MAPPER[amazonCountryCode].host }) }}
            </div>
            <div class="collapse" :style="{margin: isCollapsed ? '0' : '16px 0'}" @click="isCollapsed = !isCollapsed" v-if="isCollapsed">
              <span class="collapse-style">
                {{ isCollapsed ? $t('seller.brandsPage.expand') : $t('seller.brandsPage.collapse') }}
              </span>
              <Icon name="jiantou-you-shuang-cu" class="jiantou" :class="{ 'rotate': !isCollapsed }" />

            </div>
            </div>
            <transition name="fade-slide">
              <div v-if="!isCollapsed">
                <p class="content">
                  {{ $t('seller.brandsPage.accPolicyIntro') }}
                </p>
                <div class="bottom-content">
                  <div class="item">
                    <div class="item-top">
                      <div class="circle">
                        <div></div>
                      </div>
                      <div class="text">
                        {{ $t('seller.brandsPage.accPolicyCase1Title') }}
                      </div>
                    </div>

                    <div class="text-bottom">
                      {{ $t('seller.brandsPage.accPolicyCase1Body') }}
                    </div>
                  </div>

                </div>
                <div class="bottom-content">
                  <div class="item">
                    <div class="item-top">
                      <div class="circle">
                        <div></div>
                      </div>
                      <div class="text">
                        {{ $t('seller.brandsPage.accPolicyCase2Title') }}
                      </div>
                    </div>

                    <div class="text-bottom">
                      {{ $t('seller.brandsPage.accPolicyCase2Body') }}
                    </div>
                  </div>

                </div>
                <div class="bottom-btn">
                  <div class="btn-style" v-if="isAcc" @click="handleCheckAuthorization">
                    <Icon name="tiaozhuan" class="tiaozhuan" />
                    <span class="text-style">{{ $t('seller.brandsPage.checkAccAuthorization') }}</span>
                  </div>
                  <div v-else>
                  
                  </div>
                  <div class="collapse" @click="isCollapsed = !isCollapsed">
                    <span class="collapse-style">
                      {{ isCollapsed ? $t('seller.brandsPage.expand') : $t('seller.brandsPage.collapse') }}
                    </span>
                    <Icon name="jiantou-you-shuang-cu" class="jiantou" :class="{ 'rotate': !isCollapsed }" />

                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
      <!-- Footer Buttons -->
      <div class="modal-footer">
           <div>
        <div class="left-time" v-if="showTime">
          <span class="title">{{ $t('seller.publishersPage.effectiveTime') }}</span> <span class="content">{{ timeYYYY }} 00:00:00</span>
          <a-popover placement="top" trigger="hover">
            <template #content>
              <div class="popover-content">
                <p class="content" style="margin-bottom: 16px;">
                  {{ $t('seller.publishersPage.rateIncreaseEffective') }}
                </p>
                <p class="content">
                  {{ $t('seller.publishersPage.rateDecreaseEffective') }}
                </p>
              </div>
            </template>
            <Icon name="wenhao-tianchong" class="question" />
          </a-popover>
        </div>
      </div>
        <div class="btn-box">
        <div @click="handleClose" class="cancel-button">{{ $t('seller.common.cancel') }}</div>
        <artmisads-button type="primary" @click="handleSave" :loading="saving">
          {{ $t('seller.brandsPage.save') }}
        </artmisads-button>
        </div>
      </div>
    </div>
  </artmisads-modal>
</template>

<script setup>
import { ref, reactive, watch, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { message } from 'ant-design-vue'
import moment from 'moment'
import { publishersApi } from '@/server'
import Status from '~/components/Status.vue'
import { productsApi } from '~/server/index'
import Icon from '@/components/Icon.vue'
import { countBrandNames } from '~/utils'
import LogoImage from '@/components/LogoImage.vue'
import { CURRENCY_MAPPER } from '@/contants/common'
import { useUserInfoStore } from '@/storeData/index'
import { COUNTRY_TIME_TZ } from '~/contants/common.js'
import { useSystemStore } from '@/storeData/system'
const emit = defineEmits(['refresh'])
const { t } = useI18n()
const store = useUserInfoStore()
const systemStore = useSystemStore()
const isAcc = computed(() => systemStore.isAcc)

const userInfo = store.userInfo
const amazonCountryCode = ref('')
const isCollapsed = ref(false)
const showTime=ref(false)
const timeYYYY = ref('')
const timezone = COUNTRY_TIME_TZ[store.userInfo.countryCode]
watch(() => userInfo.countryCode, () => {
  amazonCountryCode.value = userInfo.countryCode
}, { immediate: true })
const currentTags = ref([])
const visible = ref(false)
const saving = ref(false)
const editData = ref({})
const isAutoRenew = ref(false)
const initEndDate = ref(null)
const formData = reactive({
  currentCommissionRate: '',
  startDate: null,
  endDate: null,
  status: '',
  brandName: '',
  brandId: '',
  publisherId: '',
  type: 'single'
})

const modalTitle = computed(() => {
  if (formData.type === 'single') return t('seller.brandsPage.setUpCommissionTitle')
  if (formData.status === 'active') return t('seller.publishersPage.editPartneredBrandsTitle')
  return t('seller.brandsPage.setUpAssociatePartnershipTitle')
})

const showStartDate = () => {
  if (formData.type == 'single') {
    return true
  }
  else {
    if (formData.status === 'active') {
      return false
    } else {
      return true
    }
  }
}
const handleCheckAuthorization = () => {
  window.open(`/seller/creatorConnections/authorization`)
}
const showModal = async (record) => {

  editData.value = { ...record }
  const brandList = editData.value.brandList
  // currentTags.value = brandList.map(item=>item.amazonBrandName)
  if (editData.value.type === 'multi') {
    const brandNameCount = countBrandNames(brandList, 'amazonBrandName')
    currentTags.value = brandList.map(item => {
      return {
        ...item,
        hasDuplicate: item.amazonBrandName && brandNameCount[item.amazonBrandName] > 1
      }
    })

  }
  // console.log(currentTags.value,'brandNameCount')
  // console.log(editData.value,'editData.value')
  // await getRate()
  commission.value = record?.lastCommissionRate
  initCommission.value = record?.commissionRate ?? ''

  // Initialize form data
  formData.currentCommissionRate = record?.commissionRate ?? ''
  formData.type = record.type || 'single'
  formData.status = record.status
  formData.brandName = record.amazonBrandName
  formData.brandId = record.brandId
  formData.publisherId = record.publisherId
  // For month picker, display the end of the month
  // If startDate is earlier than today, set it to today
  if (record.startDateStr) {
    const startDate = moment(record.startDateStr)
    formData.startDate = startDate.isBefore(moment(), 'day') ? moment() : startDate
  } else {
    formData.startDate = ''
  }
  isAutoRenew.value = false
  // If endDate is earlier than current month, set it to current month end
  if (record.endDateStr) {
    const endDate = moment(record.endDateStr).endOf('month')
    formData.endDate = endDate.isBefore(moment(), 'month') ? moment().endOf('month') : endDate
    if (record.endDateStr === '2099-12-31') {
      isAutoRenew.value = true
    }
  } else {
    formData.endDate = null
  }
  initEndDate.value = formData.endDate


  visible.value = true
}

// Handle start date change
const handleStartDateChange = (date) => {
  if (date) {
    formData.startDate = moment(date)

    // If end date exists and is before start date, clear end date
    if (formData.endDate && moment(formData.endDate).isBefore(moment(date), 'month')) {
      formData.endDate = null
    }
  }
}

// Handle month selection to set it to the last day of the month
const handleEndDateChange = (date) => {
  if (date) {
    const selectedEndDate = moment(date).endOf('month')

    // If end date is before start date, clear end date
    if (formData.startDate && selectedEndDate.isBefore(moment(formData.startDate), 'month')) {
      formData.endDate = null
      return
    }

    formData.endDate = selectedEndDate
  }
}




const handleClose = () => {
  visible.value = false
  // Reset form
  formData.currentCommissionRate = ''
  formData.startDate = null
  formData.endDate = null
  saving.value = false
}

const handleAutoRenewChange = (e) => {

  console.log(e, 'e', isAutoRenew.value)
  if (isAutoRenew.value) {
    formData.endDate = moment('2099-12-31', 'YYYY-MM-DD')
  } else {
    formData.endDate = initEndDate.value
  }
}

const handleRadioClick = (e) => {
  // 如果当前已经是选中状态，则取消选中
  if (isAutoRenew.value) {
    e.preventDefault()
    isAutoRenew.value = false
    // 手动触发 change 事件
    handleAutoRenewChange({ target: { checked: false } })
  } else {
    // 如果当前未选中，则选中
    e.preventDefault()
    isAutoRenew.value = true
    // 手动触发 change 事件
    handleAutoRenewChange({ target: { checked: true } })
  }
}

const disabledStartDate = (current) => {
  // Start date should not be before today
  return current && current.isBefore(moment(), 'day')
}

const disabledEndDate = (current) => {
  if (formData.type === 'multi' && formData.status === 'active') {
    return current && current.isSameOrBefore(moment(), 'month')
  }
  // End month should not be before start date month and should not be before current month
  return current && ((formData.startDate && current.isBefore(formData.startDate, 'month')) || current.isBefore(moment(), 'month'))
}

const handleSave = async () => {
  // Validation
  if (!validateForm()) {
    return
  }

  // const commissionRate = parseFloat(formData.currentCommissionRate)
  // if (isNaN(commissionRate) || commissionRate < 0 || commissionRate > 100) {
  //   message.error('Commission rate must be between 0 and 100')
  //   return
  // }

  saving.value = true

  try {
    let res
    if (formData.type === 'single') {
      console.log(editData.value, 'editData.value')
      const payload = {
        publisherId: editData.value.publisherId,
        brandId: editData.value.brandId,
        commissionRate: commission.value,
        // platformFeeRate:fees.value,
        startDate: formData.startDate.format('YYYY-MM-DD'),
        endDate: formData.endDate.format('YYYY-MM-DD')
      }
      // console.log(payload,'payload')
      res = await publishersApi.updatePublisherCommission(payload)
    }
    else {
      const commissionList = currentTags.value.map(item => {
        return {
          publisherId: item.publisherId,
          brandId: item.brandId,
          commissionRate: commission.value ? commission.value : item.commissionRate,
          startDate: formData.status === 'active' ? item.startDateStr : formData.startDate.format('YYYY-MM-DD'),
          endDate: formData.endDate.format('YYYY-MM-DD'),
          platformFeeRate: 3
        }
      })

      res = await publishersApi.updatePublisherCommissionBatch({ commissionList: commissionList })
    }
    if (res.success) {
      message.success(t('seller.msg.updatedSuccessfully'))
      emit('refresh')
      handleClose()
    } else {
      message.error(res.error || t('seller.msg.updateFailed'))
    }
  } catch (error) {
    message.error(t('seller.msg.updateFailed'))
    console.error('Update error:', error)
  } finally {
    saving.value = false
  }

}

// 表单验证函数
const validateForm = () => {




  // 特殊验证：multi类型且状态为active时，只需要结束日期
  if (formData.type === 'multi' && formData.status === 'active') {
    if (!formData.endDate) {
      message.error(t('seller.msg.selectCollaborationPeriod'))
      return false
    }
    // multi类型active状态下不需要佣金率验证，因为可能只是延长合作期间
    return true
  }
  // 验证佣金率（允许0，但不允许空）
  if (commission.value === '' || commission.value === null || commission.value === undefined) {
    message.error(t('seller.msg.enterPublisherCommission'))
    return false
  }
  if (commission.value == 0) {
    message.error(t('seller.msg.commissionGreaterThanZero'))
    return false
  }
  // 验证合作期间
  if (!formData.startDate || !formData.endDate) {
    message.error(t('seller.msg.selectCollaborationPeriod'))
    return false
  }
  // 其他情况都需要完整的验证
  return true
}

// 中间输入框逻辑
const commission = ref('')
const showDefalutText = ref(true)
const commissionMinRef = ref(null)
const initCommission = ref('')

const defaultCommission = ref({
  defaultCommissionRate: 1,
  platformFeeFactor: 1,
  platformMaxFeeRate: 1,
})
function commissionBlur (e) {
  const newValue = e.target.value
    .replace(/[^0-9.]/g, '')
    .split('.')
    .map((v, i) => {
      v = v ? parseInt(v) : null

      if (i && v) {
        v = 5
      }

      return v
    })
    .join('.')
  let data = Number(newValue)
  data = data > 99 ? 99 : data
  // 将替换后的字符串转换为数字并赋值给 commission
  commission.value = data
}

const handleChangeCommission = (e) => {
  commission.value = e
  if (e)   if (e) {
    showTime.value = true
    // 
    let nextWorkingDay = moment().tz(timezone)
    let workingDaysCount = 0
    if (commission.value > initCommission.value) {
     while (workingDaysCount < 1) {
      nextWorkingDay = nextWorkingDay.add(1, 'day')
      if (nextWorkingDay.day() !== 0 && nextWorkingDay.day() !== 6) {
        workingDaysCount++
      }
    }
    } else {
     while (workingDaysCount < 4) {
      nextWorkingDay = nextWorkingDay.add(1, 'day')
      if (nextWorkingDay.day() !== 0 && nextWorkingDay.day() !== 6) {
        workingDaysCount++
      }
    }
     
    }
     timeYYYY.value = nextWorkingDay.format('YYYY-MM-DD')
  }
  // dataSource.value.forEach(item => {
  //   if(commission.value>Number(item.accCommission.replace("%", ""))){
  //     item.commission =commission.value - Number(item.accCommission.replace("%", ""))
  //   }else{
  //     item.commission = 0
  //   }
  // })
}

const isCommissionDisabled = computed(() => {
  if (formData.type === 'multi') {
    return true
  }
  if (formData.status === 'inactive') return true
  // 当下个月还在End Date内才可以编辑
  if (!formData.endDate) return false

  const nextMonth = moment().add(1, 'month').startOf('month')
  const selectedEndMonth = moment(formData.endDate).startOf('month')

  // 如果End Date >= 下个月，则可以编辑（返回true）
  return selectedEndMonth.isSameOrAfter(nextMonth)
})

const fees = computed(() => {
  let value = 0
  if (commission.value) {
    value = (commission.value * defaultCommission.value.platformFeeFactor) / 100
  } else {
    value =
      (defaultCommission.value.defaultCommissionRate *
        defaultCommission.value.platformFeeFactor) /
      100
    if (commission.value == 0) {
      value =
        (commission.value * defaultCommission.value.platformFeeFactor) / 100
    }
  }
  if (value >= defaultCommission.value.platformMaxFeeRate) {
    value = defaultCommission.value.platformMaxFeeRate
  }
  let arr = value && value.toString().split('.')
  let firstNumber = arr && Number(arr[0])
  let middleNum = '0'
  if (arr && arr.length > 1) {
    middleNum = Number(arr[1][0])
    if (arr[1][1] == 5) {
      if (arr[1][0] % 2 !== 0) {
        middleNum += 1
        if (arr[1][0] == 9) {
          middleNum = 0
          firstNumber += 1
        }
      }
    } else if (arr[1][1] > 5) {
      middleNum += 1
      if (arr[1][0] == 9) {
        middleNum = 0
        firstNumber += 1
      }
    }
  }
  let endNum = arr && parseFloat(firstNumber + '.' + middleNum)
  return endNum
})
defineExpose({
  showModal
})
</script>

<style scoped lang="less">
  .left-time {
  display: flex;
  align-items: center;
  gap: 8px;

  .title {
    font-family: Sora;
    font-weight: 400;
    font-style: Regular;
    font-size: 13px;
    leading-trim: NONE;
    line-height: 19px;
    letter-spacing: 0.4px;
    color: rgba(15, 6, 41, 0.7);

  }

  .content {
    font-family: Sora;
    font-weight: 500;
    font-size: 13px;
    leading-trim: NONE;
    line-height: 19px;
    letter-spacing: 0.4px;
    color: rgba(15, 6, 41, 1);
  }

  .question {
    color: rgba(245, 155, 0, 1);
  }
}
  .btn-box {
    display: flex;
    gap: 12px;
  }
.collapseBox {
  .collapse {
    display: flex;
    align-items: center;
    gap: 4px;
    margin: 16px 0;
    cursor: pointer;

    .jiantou {

      color: rgba(15, 6, 41, 0.9);
    }

    .collapse-style {
      color: rgba(15, 6, 41, 0.9);
      font-family: Sora;
      font-weight: 400;
      font-size: 14px;


    }
  }

  .top {
    position: relative;
    display: flex;
    background-color: rgba(255, 245, 229, 1);
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
    margin-top: 16px;
    box-shadow: 0px 1px 0px 0px rgba(15, 6, 41, 0.05);
    border: 1px solid rgba(255, 150, 25, 1);
    border-radius: 8px;
    padding: 16px;

    .tianchong {
      color: rgba(245, 155, 0, 1);

      margin-right: 16px;
      width: 16px;
      height: 16px;
    }

    .content {
      flex: 1;

      .title {
        font-family: Sora;
        font-weight: 600;
        font-style: SemiBold;
        font-size: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .content {
        font-family: Sora;
        font-weight: 400;
        font-style: Regular;
        font-size: 14px;
        margin-top: 10px;

      }

      .bottom-content {
        margin-top: 10px;

        .item {
          background-color: rgba(255, 255, 255, 0.8);
          border-radius: 8px;
          padding: 12px 16px;

          .item-top {
            display: flex;
            align-items: center;
            gap: 10px;
          }

          .circle {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 14px;
            height: 14px;

            border-radius: 50%;
            background: rgba(245, 155, 0, 0.2);

            >div {
              width: 6px;
              height: 6px;
              border-radius: 50%;
              background-color: rgba(245, 155, 0, 1);
            }
          }

          .text {
            font-family: Sora;
            font-weight: 600;
            font-style: SemiBold;
            font-size: 13px;
            color: rgba(230, 130, 0, 1);

          }

          .text-bottom {
            font-family: Sora;
            font-weight: 400;
            font-style: Regular;
            font-size: 13px;
            color: rgba(15, 6, 41, 1);
          }
        }
      }
    }

    .bottom-btn {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 16px;

      .btn-style {
        cursor: pointer;
        display: flex;
        align-items: center;
        background-color: rgba(245, 155, 0, 1);
        border-radius: 90px;
        gap: 10px;
        padding: 6px 16px;

        .tiaozhuan {
          color: #fff;
        }

        .jiantou {}

        .text-style {
          color: #fff;
        }
      }

    }
  }
}

.edit-modal {
  :deep(.ant-radio-wrapper .ant-radio) {
    margin-top: -1px;
  }

  :deep(.ant-radio-wrapper .ant-radio-inner) {
    border-color: #7653DA;

  }

  .tags-container {
    // min-height: 60px;
    // padding: 12px;
    // border: 1px dashed #d9d9d9;
    // border-radius: 6px;
    // background: #50408014;
    margin-bottom: 40px;
    display: flex;
    flex-wrap: wrap;
    gap: 12px;

    .tag-item {
      display: flex;
      padding: 3px 4px;
      align-items: center;
      gap: 6px;
      border-radius: 6px;
      background: #F1F0F5;
      // margin: 4px 8px 4px 0;
      // padding: 4px 8px;

      font-size: 13px;

      font-weight: 400;
      line-height: 15px;
      letter-spacing: 0.3px;

      span {
        font-family: "Sora";
        opacity: 0.7;
        color: #0f0629;
      }
    }

    .tags-empty {
      color: #999;
      font-style: italic;
      font-size: 13px;
    }
  }

  .brand-section-multi {
    border-radius: 8px;
    background: #50408014;
    flex: 1;
    padding: 12px 12px 12px 0;
    display: flex;
    gap: 12px;
    flex-wrap: wrap;

  }

  .brand-section {

    .brand-info {
      margin-bottom: 40px;
      display: flex;
      justify-content: space-around;

      .info-item-content {
        // border-left: 3px solid #7653DA;
        padding-left: 12px;
      }

      .info-item:last-child {
        margin-left: 12px;
      }

      .info-item:first-child {
        margin-right: 12px;
      }

      .info-item {

        // margin-bottom: 8px;
        border-radius: 8px;
        background: #50408014;
        flex: 1;
        padding: 12px 12px 12px 0;

        .label {
          color: #0f0629;
          font-family: "Sora";
          font-size: 13px;
          font-style: normal;
          font-weight: 500;
          letter-spacing: 0.3px;
          opacity: 0.7;
        }

        .value {
          color: #0f0629;
          font-family: "Sora";
          font-size: 18px;
          font-style: normal;
          font-weight: 600;
          line-height: 26px;
          letter-spacing: 0.5px;
          opacity: 0.9;
        }
      }
    }


  }

  .title {
    color: #0f0629;
    font-family: "Sora";
    font-size: 16px;
    font-style: normal;
    font-weight: 600;

    letter-spacing: 0.4px;
    opacity: 0.9;
  }

  .commission-section {
    margin-bottom: 40px;
  }

  .content {
    display: flex;
    flex-direction: column;
    // margin-top: 8px;
    // margin-bottom: 20px;

    .commission {
      display: flex;

      >span {
        align-self: center;
        margin: 20px 10px 0 10px;
        font-family: Sora, sans-serif;
        font-weight: 500;
        color: #0f0629;
      }

      .fees,
      .total,
      .commission-input {
        display: flex;
        flex-direction: column;

        >span {
          margin-bottom: 6px;
          font-weight: 500;
          color: var(--dark-2);
          line-height: 19px;
        }
      }

      .commission-input {
        position: relative;

        .defalut-text {
          position: absolute;
          font-family: Sora, sans-serif;
          color: var(--dark-4);
          line-height: 20px;
          left: 15px;
          top: 34px;
          margin: 0;
        }

        .haifenhao {
          position: absolute;
          font-weight: 500;
          font-size: var(--font-size-large);
          color: var(--dark-1);
          right: 30px;
          top: 34px;
          margin: 0;
        }

        :deep(.ant-input-number) {
          width: 200px;

          .ant-input-number-handler-wrap {
            opacity: 1;
          }
        }
      }

      .total {
        >button {
          width: 96px;
          display: flex;
          justify-content: space-between;

          >span {
            align-self: center;
          }
        }
      }

      .fees {
        >button {
          width: 144px;
        }

        .question-icon {
          margin-left: 3px;
          color: var(--yellow-4);
        }
      }

      .fees,
      .total {
        >button {
          padding-left: 12px;
          text-align: left;
          border-radius: 8px;
          font-weight: 500;
          font-size: var(--font-size-large);
          color: var(--dark-1);
        }
      }
    }
  }

  .current-commission {
    display: flex;
    align-items: center;

    margin-bottom: 40px;

    >button {
      margin-left: 16px;
      padding-left: 12px;
      text-align: left;
      border-radius: 8px;
      font-weight: 500;
      font-size: var(--font-size-large);
      color: var(--dark-1) !important;
      min-width: 62px !important;
      max-width: 62px !important;
      padding: 0 !important;
      text-align: center !important;
    }
  }

  :deep(.artmisads-button.artmisads-default:disabled) {
    background: #EEEDF2 !important;
    border: 1px solid #CCC7D9 !important;
  }


  .collaboration-section {
    margin-bottom: 26px;

    .section-title {
      color: #0f0629;
      font-family: "Sora";
      font-size: 16px;
      font-style: normal;
      font-weight: 600;

      letter-spacing: 0.4px;
      opacity: 0.9;
      margin-bottom: 8px;
    }

    .date-row {
      display: flex;
      gap: 24px;

      .date-group {
        flex: 1;

        .date-label {
          font-size: 14px;
          color: rgba(15, 6, 41, 0.8);
          margin-bottom: 8px;
          font-weight: 500;
        }

        .date-picker {
          width: 100%;
        }
      }
    }
  }

  .auto-renew-section {
    margin-bottom: 26px;
  }

  .modal-footer {
  display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 16px;
    border-top: 1px solid #f0f0f0;
    width: 100%;
    .cancel-button {
      min-width: 96px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #0f0629;
      font-family: "Sora";
      font-size: 14px;
      font-weight: 500;

      letter-spacing: 0.4px;
      opacity: 0.7;
    }

    .artmisads-button {
      min-width: 96px;
      font-family: "Sora";
      font-weight: 500;
    }
  }

/* 动画效果 */
.jiantou {
  transition: transform 0.3s ease;
  transform: rotate(90deg);
}

.jiantou.rotate {
  transform: rotate(270deg);
}

/* 内容展开/折叠动画 */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s ease;
  max-height: 500px;
  overflow: hidden;
  opacity: 1;
}

.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  max-height: 0;
  overflow: hidden;
}
}
</style>